export enum FormElementType {
    SECTION = 'SECTION',
    QUESTION = 'QUESTION'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/form-element-type.ts